import { render, staticRenderFns } from "./ordered-products.vue?vue&type=template&id=02fbf2fe&scoped=true"
import script from "./ordered-products.vue?vue&type=script&lang=js"
export * from "./ordered-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fbf2fe",
  null
  
)

export default component.exports